import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SurveyInstancePage } from './pages/SurveyInstancePage';

const SurveyInstanceRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Survey instance management page - isolated layout */}
      <Route index element={<SurveyInstancePage />} />

      {/* Redirect any other paths */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default SurveyInstanceRoutes;
